import React from "react";

const FullArrowRightIcon = () => {
  return (
    <svg
      width="12"
      height="10"
      viewBox="0 0 12 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.08337 4.00169H8.99004L6.57004 1.09502C6.45688 0.958878 6.40244 0.783358 6.41869 0.607074C6.43495 0.430789 6.52056 0.268182 6.65671 0.155023C6.79285 0.0418636 6.96837 -0.0125777 7.14466 0.00367549C7.32094 0.0199286 7.48355 0.105545 7.59671 0.241689L10.93 4.24169C10.9525 4.27351 10.9725 4.30693 10.99 4.34169C10.99 4.37502 10.99 4.39502 11.0367 4.42836C11.0669 4.5048 11.0827 4.58616 11.0834 4.66836C11.0827 4.75055 11.0669 4.83192 11.0367 4.90836C11.0367 4.94169 11.0367 4.96169 10.99 4.99502C10.9725 5.02978 10.9525 5.06321 10.93 5.09502L7.59671 9.09502C7.53403 9.17028 7.45553 9.2308 7.36681 9.27228C7.27809 9.31376 7.18131 9.33518 7.08337 9.33502C6.92761 9.33533 6.77665 9.28108 6.65671 9.18169C6.5892 9.12572 6.5334 9.05699 6.4925 8.97942C6.4516 8.90186 6.4264 8.81699 6.41835 8.72967C6.4103 8.64235 6.41955 8.55431 6.44558 8.47057C6.47161 8.38683 6.51391 8.30906 6.57004 8.24169L8.99004 5.33502H1.08337C0.906563 5.33502 0.736993 5.26478 0.611969 5.13976C0.486944 5.01474 0.416707 4.84517 0.416707 4.66836C0.416707 4.49155 0.486944 4.32198 0.611969 4.19695C0.736993 4.07193 0.906563 4.00169 1.08337 4.00169Z"
        fill="white"
      />
    </svg>
  );
};

export default FullArrowRightIcon;
